/* eslint-disable */
import React from 'react';

export const DropPin = ({ w, h }) => {
  return (
    <React.Fragment>
      <svg width={w} height={h} viewBox="0 0 256 256" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g
          style={{
            stroke: 'none',
            strokeWidth: 0,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fill: 'none',
            fillRule: 'nonzero',
            opacity: 1
          }}
          transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
        >
        	<path
            d="M 45 0 c 15.103 0 27.389 12.287 27.389 27.389 C 72.389 46.616 46.147 66.607 45 90 c -1.147 -23.393 -27.389 -43.384 -27.389 -62.611 C 17.611 12.287 29.897 0 45 0 z"
            style={{
              stroke: 'none',
              strokeWidth: 1,
              strokeDasharray: 'none',
              strokeLinecap: 'butt',
              strokeLinejoin: 'miter',
              strokeMiterlimit: 10,
              fill: 'rgb(255, 80, 80)',
              fillRule: 'nonzero',
              opacity: 1
            }}
            transform=" matrix(1 0 0 1 0 0) "
            strokeLinecap="round"
          />
        	<circle
            cx="45.004999999999995"
            cy="26.575000000000003"
            r="9.205"
            style={{
              stroke: 'none',
              strokeWidth: 1,
              strokeDasharray: 'none',
              strokeLinecap: 'butt',
              strokeLinejoin: 'miter',
              strokeMiterlimit: 10,
              fill: 'rgb(191, 0, 3)',
              fillRule: 'nonzero',
              opacity: 1
            }}
            transform="  matrix(1 0 0 1 0 0) "
          />
        </g>
      </svg>
    </React.Fragment>
  );
};
